import { colors } from "src/theme/colors";

/* The app background, taken from the football web app's `canvas` token so
   the two products sit on the same ground. The accent stays FinaMaze blue. */
export const GREY = "#F6F7F9";
export const WHITE = "#FFFFFF";
export const BLUE = colors.primary[500];
